<ng-template [ngIf]="responsable">
  <mat-toolbar class="dialog-title">
    <span>Agregar unidad orgánica</span>
    <div (click)="cerrar()" class="close-dialog">
      <i class="fas fa-times"></i>
    </div>
  </mat-toolbar>
  <mat-form-field *ngIf="responsable.entidad && this.entidadList.length>0" appearance="outline" class="field-meta-100">
    <mat-label>Entidad <span style="color: red;">*</span></mat-label>
    <mat-select (selectionChange)="cargarSelectHijos(responsable.entidad,undefined,false)" [(ngModel)]="responsable.entidad" required>
      <mat-option></mat-option>
      <mat-option *ngFor="let entidad of entidadList" [value]="entidad">
        {{entidad.nombre}}
      </mat-option>
    </mat-select>
  </mat-form-field>

  <mat-form-field *ngIf="responsable.despacho && this.despachoList.length>0" appearance="outline" class="field-meta-100">
    <mat-label>Despacho </mat-label>
    <mat-select (selectionChange)="cargarSelectHijos(responsable.despacho,'1',false)" [(ngModel)]="responsable.despacho" >
      <mat-option></mat-option>
      <mat-option *ngFor="let despacho of despachoList" [value]="despacho">
        {{despacho.nombre}}
      </mat-option>
    </mat-select>
  </mat-form-field>

  <mat-form-field *ngIf="responsable.direccionGeneral && this.direccionGeneralList.length>0" appearance="outline" class="field-meta-100">
    <mat-label>Dirección General</mat-label>
    <mat-select (selectionChange)="cargarSelectHijos(responsable.direccionGeneral,'2',false)" [(ngModel)]="responsable.direccionGeneral" >
      <mat-option></mat-option>
      <mat-option *ngFor="let direccionGeneral of direccionGeneralList" [value]="direccionGeneral">
        {{direccionGeneral.nombre}}
      </mat-option>
    </mat-select>
  </mat-form-field>


  <mat-form-field *ngIf="responsable.direccionLinea && this.direccionLineaList.length>0" appearance="outline" class="field-meta-100">
    <mat-label>Dirección de Línea</mat-label>
    <mat-select (selectionChange)="cargarSelectHijos(responsable.direccionLinea,'3',false)" [(ngModel)]="responsable.direccionLinea" >
      <mat-option></mat-option>
      <mat-option *ngFor="let direccionLinea of direccionLineaList" [value]="direccionLinea">
        {{direccionLinea.nombre}}
      </mat-option>
    </mat-select>
  </mat-form-field>

  <mat-form-field *ngIf="responsable.area && this.areaList.length>0" appearance="outline" class="field-meta-100">
    <mat-label>Área responsable</mat-label>
    <mat-select [(ngModel)]="responsable.area">
      <mat-option></mat-option>
      <mat-option *ngFor="let area of areaList" [value]="area">
        {{area.nombre}}
      </mat-option>
    </mat-select>
  </mat-form-field>

  <div class="dialog-buttons">
    <button mat-raised-button [disabled]="!responsable.entidad.id" class="btn_olive" (click)="addUnidadOrganica()">Agregar</button>&nbsp;
    <button mat-raised-button class="btn_danger" (click)="cerrar()">Cancelar</button>
  </div>

</ng-template>
